interface AvatarProps {
  src: string;
  size: number;
}

export const Avatar = ({ src = '/', size }: AvatarProps) => {
  return (
    <img
      className="rounded-full object-cover"
      src={src}
      alt="avatar"
      style={{ width: size, height: size }}
    />
  );
};
